import { Clock, Sun, Moon, Flame, Info } from "lucide-react";
import { useFetch } from "../lib/useData";
import { PageHero, Section } from "../components/public/PublicLayout";

const HERO = "https://images.pexels.com/photos/37650548/pexels-photo-37650548.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=1600";

export default function Timings() {
  const { data: t } = useFetch("/public/timings");
  const { data: today } = useFetch("/public/today-schedule");

  return (
    <div>
      <PageHero title="Darshan & Temple Timings" subtitle="Plan your visit for darshan and aarti" image={HERO} />
      <Section>
        <div className="rounded-2xl bg-emerald-50 border border-emerald-200 p-5 flex gap-3 items-start mb-10" data-testid="darshan-note">
          <Info className="w-5 h-5 text-emerald-700 shrink-0 mt-0.5" />
          <p className="text-emerald-900 font-medium">{t?.darshan_note || "Darshan does not require advance booking."}</p>
        </div>

        {today && (
          <div className="rounded-2xl bg-orange-600 text-white p-6 mb-10" data-testid="today-box">
            <div className="text-sm uppercase tracking-widest font-semibold text-amber-100">Today · {today.weekday}, {today.date}</div>
            {today.special_activity && <div className="text-lg font-bold mt-1">{today.special_activity}</div>}
            {today.special_override && <div className="mt-2 text-amber-50">Special schedule: {today.special_override.note}</div>}
          </div>
        )}

        <div className="grid md:grid-cols-2 gap-6">
          <div className="bg-white rounded-2xl border border-amber-200 p-7">
            <div className="flex items-center gap-2 text-orange-700 mb-4"><Sun className="w-5 h-5" /><h3 className="font-display text-xl font-bold">Morning</h3></div>
            <p className="text-2xl font-extrabold text-stone-900">{t?.morning_hours}</p>
            <div className="flex items-center gap-2 mt-4 text-stone-600"><Clock className="w-4 h-4" /> Morning Aarti: <strong>{t?.morning_aarti}</strong></div>
          </div>
          <div className="bg-white rounded-2xl border border-amber-200 p-7">
            <div className="flex items-center gap-2 text-orange-700 mb-4"><Moon className="w-5 h-5" /><h3 className="font-display text-xl font-bold">Evening</h3></div>
            <p className="text-2xl font-extrabold text-stone-900">{t?.evening_hours}</p>
            <div className="flex items-center gap-2 mt-4 text-stone-600"><Clock className="w-4 h-4" /> Evening Aarti: <strong>{t?.evening_aarti}</strong></div>
          </div>
        </div>

        <h3 className="font-display text-2xl font-bold text-stone-900 mt-12 mb-5 flex items-center gap-2"><Flame className="w-6 h-6 text-orange-600" /> Other Activities</h3>
        <div className="grid sm:grid-cols-2 gap-4">
          {(t?.activities || []).map((a, i) => (
            <div key={i} className="flex items-center justify-between bg-amber-50 border border-amber-200 rounded-xl px-5 py-4">
              <span className="font-semibold text-stone-800">{a.name}</span>
              <span className="text-orange-700 font-bold">{a.time}</span>
            </div>
          ))}
        </div>

        <h3 className="font-display text-2xl font-bold text-stone-900 mt-12 mb-5">The Week at a Glance</h3>
        <div className="overflow-hidden rounded-2xl border border-amber-200">
          <table className="w-full text-left" data-testid="weekly-schedule">
            <tbody>
              {(t?.weekly_schedule || []).map((w, i) => (
                <tr key={i} className={i % 2 ? "bg-amber-50/50" : "bg-white"}>
                  <td className="px-6 py-4 font-bold text-stone-800 w-40">{w.day}</td>
                  <td className="px-6 py-4 text-stone-600">{w.activity}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Section>
    </div>
  );
}
